<template>
  <div>
    <div v-show="visible_doc_table" class="docTable">
      <a-drawer
        :title="previewFileName"
        placement="left"
        width="60%"
        @close="onClose"
        :visible="isPreviewVisible"
      >
        <a-spin :spinning="spinningPreview">
          <div
            style="
              display: flex;
              justify-content: space-between;
              padding-bottom: 5px;
            "
          >
            <a-button
              :disabled="currentPage - 1 < 1 ? true : false"
              @click="
                () => {
                  currentPage--;
                  preview({ file: fileSave });
                }
              "
            >
              <a-icon type="left" />
              {{ $t("Prev") }}
            </a-button>
            <span>{{ currentPage }} / {{ countPages }}</span>
            <a-button
              :disabled="currentPage + 1 > countPages ? true : false"
              @click="
                () => {
                  currentPage++;
                  preview({ file: fileSave });
                }
              "
            >
              {{ $t("Next") }}
              <a-icon type="right" />
            </a-button>
          </div>
          <div style="position: relative">
            <canvas
              v-if="docPdf === true"
              id="pdf-canvas-table"
              class="pdf-canvas"
            ></canvas>
            <img v-else :src="`${docPdf}`" style="width: 100%" />
            <div id="text-layer-table" class="text-layer"></div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <a-button
              :disabled="currentPage - 1 < 1 ? true : false"
              @click="
                () => {
                  currentPage--;
                  preview({ file: fileSave });
                }
              "
            >
              <a-icon type="left" />
              {{ $t("Prev") }}
            </a-button>
            <span>{{ currentPage }} / {{ countPages }}</span>
            <a-button
              :disabled="currentPage + 1 > countPages ? true : false"
              @click="
                () => {
                  currentPage++;
                  preview({ file: fileSave });
                }
              "
            >
              {{ $t("Next") }}
              <a-icon type="right" />
            </a-button>
          </div>
        </a-spin>
      </a-drawer>
      <div class="documentSearch">
        <div class="functionalRow">
          <a-upload
            :fileList="fileList"
            :beforeUpload="beforeUpload"
            :multiple="true"
          >
            <a-button
              hidden
              type="primary"
              icon="upload"
              :loading="uploading"
              :disabled="isUploadingDisable"
            />
          </a-upload>
          <a-row type="flex" class="search-wrapper">
            <a-col style="flex: 1; margin-right: 15px">
              <a-dropdown :trigger="['click']" v-model="openFilter">
                <a-input-search
                  class="ant-dropdown-link"
                  v-model="searchlabel"
                  @search="handleSearch()"
                  :placeholder="$t('Search by name')"
                />
                <a-menu slot="overlay" style="background-color: #fafafa">
                  <a-form
                    :form="form"
                    id="my_form_search_styl"
                    layout="vertical"
                    style="padding: 0 50px"
                  >
                    <a-menu-item key="2">
                      <a-form-item :label="$t('Status')">
                        <a-select
                          allowClear
                          mode="multiple"
                          v-decorator="[
                            'status',
                            { rules: [{ required: false }], initialValue: [] },
                          ]"
                        >
                          <a-select-option value="NOWY">{{
                            $t("NOWY")
                          }}</a-select-option>
                          <a-select-option value="DO OPISANIA">{{
                            $t("DO OPISANIA")
                          }}</a-select-option>
                          <a-select-option value="OPISANY">{{
                            $t("OPISANY")
                          }}</a-select-option>
                          <a-select-option value="ZARCHIWIZOWANY">{{
                            $t("ZARCHIWIZOWANY")
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                      <a-form-item :label="$t('Keywords')">
                        <a-select
                          allowClear
                          mode="multiple"
                          v-decorator="[
                            'tags',
                            { rules: [{ required: false }], initialValue: [] },
                          ]"
                        >
                          <a-select-option v-for="i in key_words" :key="i">{{
                            i
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                      <a-form-item :label="$t('Specialization')">
                        <a-select
                          allowClear
                          showSearch
                          optionFilterProp="children"
                          v-decorator="[
                            'SPECJALIZACJA',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option
                            v-for="i in specialization"
                            :key="i"
                            >{{ i }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-menu-item>
                    <a-menu-item key="3">
                      <a-form-item :label="$t('Document type')">
                        <a-select
                          allowClear
                          showSearch
                          optionFilterProp="children"
                          v-decorator="[
                            'document_type',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option value="Dokument zwykly">{{
                            $t("Regular document")
                          }}</a-select-option>
                          <a-select-option value="Dokument poufny">{{
                            $t("Сonfidential document")
                          }}</a-select-option>
                          <a-select-option value="FVZ">{{
                            $t("Invoice")
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-menu-item>
                    <a-menu-item key="4">
                      <a-form-item :label="$t('Contractor')">
                        <a-input
                          @click="handleChangeContractor()"
                          v-model="contactorTitle"
                        />
                      </a-form-item>

                      <a-form-item :label="$t('Contractor') + ' / NIP'" hidden>
                        <a-select
                          showSearch
                          allowClear
                          optionFilterProp="children"
                          v-decorator="[
                            'kontragent',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option
                            v-for="comp in InitInfo.company"
                            :key="comp.ID"
                            >{{ comp.TITLE }} /
                            {{ comp[companyFieldForNIP] }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-menu-item>
                    <a-menu-item key="5">
                      <a-form-item :label="$t('File creation date')">
                        <a-range-picker
                          allowClear
                          v-decorator="[
                            'CREATE_TIME',
                            {
                              rules: [{ type: 'array', required: false }],
                              initialValue: [],
                            },
                          ]"
                        />
                      </a-form-item>
                      <a-form-item :label="$t('Date of issue')">
                        <a-range-picker
                          allowClear
                          v-decorator="[
                            'date_send',
                            {
                              rules: [{ type: 'array', required: false }],
                              initialValue: [],
                            },
                          ]"
                        />
                      </a-form-item>
                    </a-menu-item>

                    <a-menu-item key="6">
                      <a-form-item
                        style="text-align: center"
                        :label-col="{ span: 0 }"
                        :wrapper-col="{ span: 24 }"
                      >
                        <a-button type="primary" @click="handleSearch()">{{
                          $t("Search")
                        }}</a-button>
                        <a-button
                          @click="handleReset()"
                          style="margin-left: 50px"
                          >{{ $t("Reset") }}</a-button
                        >
                      </a-form-item>
                    </a-menu-item>
                  </a-form>
                </a-menu>
              </a-dropdown>
            </a-col>
            <a-col>
              <a-button
                type="primary"
                :icon="iconCheck"
                @click="
                  !iconCheck ? handleSearch(['ZARCHIWIZOWANY']) : handleReset()
                "
                >{{ $t("ZARCHIWIZOWANY") }}</a-button
              >
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="documentTable">
        <a-table
          :columns="columns"
          tableLayout="auto"
          :scroll="{ x: true }"
          :dataSource="fileList"
          :pagination="{
            total: totalItems,
            current: currentPageTable,
            defaultPageSize: 10,
            pageSizeOptions: ['10', '30', '50', '100'],
            showSizeChanger: true,
          }"
          size="middle"
          :loading="loading"
          @change="onChangeTable"
          bordered
        >
          <template
            slot="name"
            slot-scope="text, record"
            style="text-align: left"
          >
            <a @click="goSteps(record)" style="text-align: left; padding: 0">{{
              text
            }}</a>
          </template>
          <template slot="time_change" slot-scope="text">{{
            text != undefined ? text : ""
          }}</template>
          <template slot="preview" slot-scope="text, record, index">
            <a-button @click="previewFile(record)" type="link" icon="eye" />
            <a-popconfirm
              :title="$t('Delete file?')"
              v-show="record.status != 'ZARCHIWIZOWANY'"
              :ok-text="$t('Tak')"
              :cancel-text="$t('Nie')"
              @confirm="handleDeleteFile(record, index)"
            >
              <a-button type="link">
                <a-icon type="delete" style="color: #ff4d4f" />
              </a-button>
            </a-popconfirm>
          </template>
        </a-table>
      </div>
    </div>
    <steps
      v-if="!visible_doc_table"
      :element="document_record"
      :profile="profile"
      :form_info="InitInfo"
      :USER_LIST="USER_LIST"
      :responsible="responsible"
      :disableFromResponsible="disableFromResponsible"
      :current="current"
      :specialization="specialization"
      :user_setup="user_setup"
      :COMPANY_LIST="COMPANY_LIST"
      :MY_COMPANY_LIST="MY_COMPANY_LIST"
      @back="onback"
      @preview="preview"
      :key_words="key_words"
    />
  </div>
</template>
<script>
import steps from "./steps.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  // Sort,
  getDocumentAllStage,
  getFilter,
  uploadFile,
  getPoglad,
  deleteFile,
  getfile,
} from "@/requestFunc";
var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");
export default {
  components: {
    steps,
  },
  props: [
    "InitInfo",
    "key_words",
    "specialization",
    "responsible",
    "user_setup",
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
  ],
  computed: { ...mapGetters(["companyFieldForNIP"]) },
  data() {
    return {
      countPages: 1,
      currentPage: 1,
      fileSave: "",
      searchlabel: "",
      isPreviewVisible: false,
      spinningPreview: true,
      previewFileName: "",
      addFileList: [],
      fileList: [],
      iconCheck: undefined,
      isUploadingDisable: true,
      totalItems: 0,
      loading: false,
      contactorTitle: "",
      openFilter: false,
      currentPageTable: 1,
      uploading: false,
      sortedInfo: { sort_column: undefined, sort_order: undefined },
      filterInfo: undefined,
      profile: {},
      part_max: 0,
      docPdf: null,
      visible_doc_table: true,
      document_record: null,
      current: 0,
      disableFromResponsible: false,
      form: this.$form.createForm(this, { name: "search" }),
      columns: [
        {
          title: this.$t("Document name"),
          dataIndex: "title",
          key: "title",
          sorter: true,
          ellipsis: true,
          customRender: (text, record) => {
            if (record.title != undefined) {
              return text;
            } else {
              return "";
            }
          },
        },
        {
          title: this.$t("File name"),
          key: "NAME",
          sorter: true,
          dataIndex: "NAME",
          ellipsis: true,
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("Date of change"),
          key: "time_change",
          sorter: true,
          dataIndex: "time_change",
          customRender: (text, record) => {
            return text
              ? moment(text).format("YYYY-MM-DD HH:mm:ss")
              : moment(record?.CREATE_TIME).format("YYYY-MM-DD HH:mm:ss");
          },
        },
        {
          title: this.$t("Źródło"),
          dataIndex: "CREATED_BY",
          sorter: true,
          customRender: (text) => {
            if (text) {
              if (text == 514) {
                return this.USER_LIST[text]["EMAIL"];
              } else {
                return (
                  this.USER_LIST[text]["NAME"] +
                  " " +
                  this.USER_LIST[text]["LAST_NAME"]
                );
              }
            } else {
              return "";
            }
          },
        },
        {
          title: this.$t("Date of issue"),
          key: "date_recept",
          sorter: true,
          dataIndex: "date_recept",
        },
        {
          title: this.$t("Tag"),
          key: "Teczka",
          align: "center",
          sorter: true,
          dataIndex: "Teczka",
          customRender: (text) => {
            var mas = [];
            if (Array.isArray(text)) {
              mas = text.map((x) => <a-tag color="blue">{x.tagData}</a-tag>);
            }
            return mas;
          },
        },
        {
          title: this.$t("Specialization"),
          key: "SPECJALIZACJA",
          align: "center",
          sorter: true,
          dataIndex: "SPECJALIZACJA",
          customRender: (text) => {
            try {
              var res = [];
              if (text != undefined && text != "" && text != "[]") {
                try {
                  text = JSON.parse(text);
                  if (typeof text == "string") throw Error;
                } catch {
                  text = [text];
                }
                for (let el of text) {
                  res.push(<a-tag color="red">{el}</a-tag>);
                }
              }
              return res;
            } catch {
              return [];
            }
          },
        },
        {
          title: this.$t("Keywords"),
          key: "key_words",
          align: "center",
          sorter: true,
          dataIndex: "key_words",
          customRender: (text) => {
            var mas = [];
            if (Array.isArray(text)) {
              mas = text.map((x) => <a-tag color="green">{x}</a-tag>);
            }
            return mas;
          },
        },
        {
          title: this.$t("Status"),
          key: "status",
          align: "center",
          sorter: true,
          fixed: "right",
          width: 150,
          dataIndex: "status",
          customRender: (text) => {
            if (text == null || text == "NOWY") {
              return <a-tag color="#029C8E">{this.$t("NOWY")}</a-tag>;
            }
            if (text == "DO OPISANIA")
              return <a-tag color="#FCB76F">{this.$t("DO OPISANIA")}</a-tag>;
            if (text == "OPISANY")
              return <a-tag color="#E88666">{this.$t("OPISANY")}</a-tag>;
            if (text == "ZARCHIWIZOWANY")
              return <a-tag color="#EA5F40">{this.$t("ZARCHIWIZOWANY")}</a-tag>;

            return this.$t(text);
          },
        },
        {
          title: this.$t("Actions"),
          dataIndex: "DOWNLOAD_URL",
          align: "center",
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "preview" },
        },
      ],
    };
  },
  methods: {
    moment,
    handleChangeContractor() {
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: true,
        },
        (info) => {
          let arrayCompanyName = [];
          let arrayCompanyID = [];
          for (let name in info.company) {
            arrayCompanyName.push(info.company[name].title);
            arrayCompanyID.push(info.company[name].id.split("_")[1]);
          }
          this.contactorTitle = arrayCompanyName.join();
          this.form.setFieldsValue({
            kontragent: arrayCompanyID,
          });
        }
      );
    },
    onClose() {
      this.isPreviewVisible = false;
      this.fileSave = undefined;
      this.resize();
    },
    previewFile(file) {
      getPoglad(file.ID).done((x) => {
        let data = JSON.parse(x);
        this.fileSave = data;
        this.preview({ file: data, page: 1 });
      });
    },
    onChangeTable(page, filter, sorter) {
      var params;
      this.form.validateFields((err, values) => {
        values["date_send"] =
          values.date_send.length != 0
            ? [
                moment(values.date_send[0]).format("YYYY-MM-DD"),
                moment(values.date_send[1]).format("YYYY-MM-DD"),
              ]
            : undefined;

        values["CREATE_TIME"] =
          values.CREATE_TIME.length != 0
            ? [
                moment(values.CREATE_TIME[0]).format("YYYY-MM-DD"),
                moment(values.CREATE_TIME[1]).format("YYYY-MM-DD"),
              ]
            : undefined;

        values["NAME"] = values.NAME == "" ? undefined : values.NAME;
        values["mpk"] = values.mpk == "" ? undefined : values.mpk;
        values["title"] = values.title == "" ? undefined : values.title;
        if (this.contractor) values.kontragent = this.contractor;
        params = values;
      });

      this.loading = true;

      getfile(page, params, sorter)
        .done((res) => {
          let result = JSON.parse(res);
          this.fileList = result.allData;
          this.totalItems = result.total;
          this.currentPageTable = page.current;
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error"));
        })
        .always(() => {
          this.loading = false;
        });
    },
    Uint8ArrayFromBase64(base64) {
      return Uint8Array.from(window.atob(base64), (v) => v.charCodeAt(0));
    },
    getMimeFromUint8Array(uint8Array) {
      const header = Array.from(uint8Array.slice(0, 4))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
      switch (header) {
        case "25504446":
          return "application/pdf"; // %PDF
        case "89504e47":
          return "image/png"; // PNG
        case "ffd8ffe0": // fallthrough
        case "ffd8ffe1":
        case "ffd8ffe2":
          return "image/jpeg"; // JPG
        default:
          return "unknown";
      }
    },

    preview({ file, page }) {
       let pdfAsArray = this.Uint8ArrayFromBase64(file.base64file);

       const mimeType = this.getMimeFromUint8Array(pdfAsArray);
      //  console.log("docTable 📂 Detected MIME type:", mimeType);

      // if (doc.NAME.indexOf(".jpg") != -1 || doc.NAME.indexOf(".png") != -1) {
      if (mimeType === "image/png" || mimeType === "image/jpeg") {
        // this.docPdf = doc.DOWNLOAD_URL;
        this.docPdf = `data:${mimeType};base64,${file.base64file}`;
        this.spinningPreview = false;
      } else {
        this.docPdf = true;
        if (page) this.currentPage = page;
        this.spinningPreview = true;
        // var url = file.DOWNLOAD_URL || file.url;
        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
        var loadingTask = pdfjsLib.getDocument(pdfAsArray);
        // var loadingTask = pdfjsLib.getDocument(url);
        loadingTask.promise.then(
          (pdf) => {
            try {
              this.countPages = pdf.numPages;
              if (1 <= this.currentPage && this.countPages >= this.currentPage)
                pdf.getPage(this.currentPage).then((page) => {
                  var canvas = document.getElementById("pdf-canvas-table");
                  let realW = $("#pdf-canvas-table").width();
                  var viewport = page.getViewport({
                    scale: realW / page.getViewport({ scale: 1.0 }).width,
                  });
                  var context = canvas.getContext("2d");
                  canvas.height = viewport.height;
                  canvas.width = viewport.width;
                  var renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                  };
                  var renderTask = page.render(renderContext);
                  renderTask.promise
                    .then(() => {
                      $("#pdf-canvas-table").css("border", "1px solid");
                      this.spinningPreview = false;
                      this.resize();
                      return page.getTextContent();
                    })
                    .then(function (textContent) {
                      var pdf_canvas = $("#pdf-canvas-table");
                      var canvas_height = pdf_canvas.get(0).height;
                      var canvas_width = pdf_canvas.get(0).width;
                      $("#text-layer-table").css({
                        // left: canvas_offset.left + "px",
                        // top: canvas_offset.top + "px",
                        left: "2px",
                        top: "2px",
                        height: canvas_height + "px",
                        width: canvas_width + "px",
                      });
                      pdfjsLib.renderTextLayer({
                        textContent: textContent,
                        container: $("#text-layer-table").get(0),
                        viewport,
                        textDivs: [],
                      });
                    });
                });
            } catch {
              this.spinningPreview = false;
            }
          },
          (reason) => {
            this.spinningPreview = false;
            console.error(reason);
          }
        );
      }
      this.previewFileName = file.NAME;
      this.isPreviewVisible = true;
    },
    beforeUpload(file) {
      this.addFileList = [...this.addFileList, file];
      this.handleUploadFile();
      return false;
    },
    handleUploadFile() {
      var formData = new FormData();
      formData.append("run", "addfile");
      formData.append("folder", this.InitInfo.user_folder);
      this.addFileList.forEach((file) => {
        formData.append("files[]", file);
      });

      this.uploading = true;
      uploadFile(formData)
        .done((x) => {
          var res = JSON.parse(x);
          this.addFileList = [];
          this.uploading = false;
          if (res["result"] == "success") {
            res.file["time_change"] = this.moment().format(
              "YYYY-MM-DD HH:mm:ss"
            );
            res.file["key"] = this.lastKeyFiles++;

            this.fileList.unshift(res.file);
            this.$message.success(this.$t("Upload successful") + ".");
          } else {
            this.$message.error(this.$t("Upload failed") + ".");
          }
        })
        .fail((e) => {
          this.uploading = false;
          console.err(e);
          this.$message.error(this.$t("Upload failed") + ".");
        });
    },
    handleSearch(input) {
      var chekField = this.form.getFieldsValue();
      if (!Object.keys(chekField).length) this.openFilter = true;

      if (this.searchlabel) {
        this.form.setFieldsValue({
          title: this.searchlabel,
        });
      }

      this.form.validateFields((err, values) => {
        if (
          $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
          $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
        ) {
          $(".search-wrapper input").click();
        }
        if (input) {
          values["status"] = input;
          this.iconCheck = "check";
        } else {
          this.iconCheck = undefined;
          values["date_send"] =
            values.date_send.length != 0
              ? [
                  moment(values.date_send[0]).format("YYYY-MM-DD"),
                  moment(values.date_send[1]).format("YYYY-MM-DD"),
                ]
              : undefined;

          values["CREATE_TIME"] =
            values.CREATE_TIME.length != 0
              ? [
                  moment(values.CREATE_TIME[0]).format("YYYY-MM-DD"),
                  moment(values.CREATE_TIME[1]).format("YYYY-MM-DD"),
                ]
              : undefined;
          values["NAME"] = values.NAME == "" ? undefined : values.NAME;
          values["mpk"] = values.mpk == "" ? undefined : values.mpk;
          if (this.searchlabel) {
            values["title"] = this.searchlabel;
          }
        }

        this.changeSpinning();

        this.filterInfo = values;
        getFilter("document", values)
          .done((data) => {
            let result = JSON.parse(data);
            this.totalItems = result.total;
            this.currentPageTable = 1;
            this.fileList = [...result.allData];
            //  this.$emit("updateFiles", { files: result.allData });
            this.$message.success(this.$t("Filter ok"));
            if (input) {
              this.form.setFieldsValue({
                status: input,
              });
            }
            this.openFilter = false;

            /*   let files = JSON.parse(data);
 
            this.$emit("updateFiles", { files });*/
          })
          .fail((e) => {
            console.err(e);
            this.$message.error(this.$t("Error loading files"));
          })
          .always(() => {
            this.changeSpinning();
          });
      });
    },
    handleReset() {
      if (
        $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
        $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
      ) {
        $(".search-wrapper input").click();
      }
      this.changeSpinning();
      this.form.resetFields();
      this.filterInfo = undefined;
      this.sortedInfo = { sort_column: undefined, sort_order: undefined };
      this.iconCheck = undefined;
      this.contractor = "";
      this.contractorTitle = "";

      getFilter("document")
        .done((data) => {
          // let elem = JSON.parse(data);

          let result = JSON.parse(data);
          this.totalItems = result.total;
          this.fileList = result.allData;
          // this.$emit("updateFiles", { files: result.allData });
          this.currentPageTable = 1;

          //this.$emit("updateFiles", { files: elem });
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading files"));
        })
        .always(() => {
          this.changeSpinning();
        });
    },
    sortField(a, b, toTheValue) {
      if (toTheValue) {
        a = toTheValue(a);
        b = toTheValue(b);
      }
      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      }
      return 0;
    },
    handleDeleteFile(file, index) {
      this.changeSpinning();
      deleteFile(file.mainid, file.ID)
        .done((res) => {
          if (res == "success") {
            this.fileList.splice(index, 1);
            this.$message.success(this.$t("File deleted"));
          } else {
            this.$message.error(this.$t("Error deleting file"));
          }
        })
        .always(() => {
          this.onChangeTable({ current: this.currentPageTable, pageSize: 10 });
          this.changeSpinning();
        });
    },
    onback(data) {
      this.visible_doc_table = true;
      if (data.remove_elem) {
        let indx = this.fileList.findIndex((x) => x.ID == data.remove_elem);
        let removed = this.fileList.splice(indx, 1);
        if (data.unshift_elem) {
          this.fileList.unshift(removed[0]);
          this.goSteps(removed[0]);
        }
        if (data.invoice && data.invoice.document_type == "FVZ") {
          if (
            this.profile.ADMIN ||
            this.InitInfo.defaultResponsible.verification.includes(
              this.profile.ID
            ) ||
            this.InitInfo.defaultResponsible.processing.includes(
              this.profile.ID
            ) ||
            [
              ...this.InitInfo.matrix[data.invoice.my_company].ASSISTANT,
              ...this.InitInfo.matrix[data.invoice.my_company].PROCESSING,
              ...this.InitInfo.matrix[data.invoice.my_company].HUBLIDER,
            ].includes(this.profile.ID)
          ) {
            this.$emit("goToInvoice", data.invoice);
          }
        }
      }
      this.resize();
    },
    changeSpinning(val) {
      this.$emit("changeSpinning", val);
    },
    goSteps(record) {
      this.changeSpinning();
      // this.disableFromResponsible = false;
      let first_stage = this.current == 0 ? true : false;
      let id_file = record.ID;

      getDocumentAllStage(first_stage, id_file)
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);
          Object.assign(record, item);
          if (!record.status || record.status == "NOWY") {
            this.current = 0;
          } else if (record.status == "DO OPISANIA") {
            this.current = 1;
          } else {
            this.current = 2;
          }
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        })
        .always(() => {
          BX24.callMethod("profile", {}, (res) => {
            this.profile = res.data();
            this.visible_doc_table = false;
            this.document_record = record;
            if (
              this.profile.ADMIN ||
              this.user_setup.responsible.includes(this.profile.ID)
            ) {
              this.disableFromResponsible = false;
            } else {
              this.disableFromResponsible = true;
            }
            this.changeSpinning();
            BX24.fitWindow();
          });
        });
    },
    checkForInvolvement(userID) {
      var mas = [
        ...this.user_setup.responsible,
        // ...this.InitInfo.defaultResponsible.processing,
        // ...this.InitInfo.defaultResponsible.verification,
      ];
      if (mas.includes(userID)) return true;
      for (let i in this.InitInfo.matrix) {
        mas = [...this.InitInfo.matrix[i].PROCESSING];
        if (mas.includes(userID)) return true;
      }
      return false;
    },
    resize() {
      setTimeout(
        () =>
          BX24.resizeWindow(
            parseInt($("body #root_block").css("width")),
            parseInt($("body #root_block").css("height"))
          ),
        100
      );
    },
  },
  mounted() {
    this.openFilter = false;
    this.totalItems = this.InitInfo.total;
    this.onChangeTable({ current: 1, pageSize: 10 });

    this.resize();
    this.changeSpinning(false);

    BX24.callMethod("profile", {}, (res) => {
      this.profile = res.data();
      this.isUploadingDisable = !(
        this.profile.ADMIN || this.checkForInvolvement(this.profile.ID)
      );
    });
  },
};
</script>
<style scoped>
.docTable {
  display: flex;
  flex-direction: column;
}
.documentSearch {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.documentSearch > div {
  margin: 5px 0px;
  width: 100%;
  text-align: left;
  align-self: flex-start;
}
.documentSearch .functionalRow {
  display: flex;
  justify-content: space-around;
  margin-bottom: 25px;
}
.documentSearch .functionalRow .documentAdd__btn {
  margin-right: 15px;
  display: flex;
  align-self: center;
}
.documentSearch .functionalRow .search-wrapper {
  width: 100%;
}
.documentTable {
  min-height: 401px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-dropdown-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.table-operations {
  margin: 10px 0;
}

.table-operations > div {
  margin-right: 10px;
}
</style>